import * as React from "react";

const SvgWordBox = (text) => (
  <svg
    width="216"
    height="85"
    viewBox="0 0 216 85"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="216" height="74" rx="37" fill="white" />
    <path
      d="M109.335 82.4802C108.742 83.5081 107.258 83.5081 106.665 82.4802L101.769 74L114.231 74L109.335 82.4802Z"
      fill="white"
    />
    <text
      // x="50%"
      y="15%"
      dominantBaseline="middle"
      textAnchor="middle"
      fill="black"
      fontSize="14"
    >
      <tspan x="50%" dy="1.2em">
        웨딩홀 선택 시 고려해야하는
      </tspan>
      <tspan x="50%" y="39%" dy="1.2em">
        조건이 너무나도 많으시죠?
      </tspan>
    </text>
  </svg>
);
export default SvgWordBox;
